import { JsonConverter, JsonCustomConvert } from 'json2typescript';

import { FatcaManagerCompanyRelation } from '../../../../../core';

@JsonConverter
export class FatcaManagerCompanyRelationAdapter implements JsonCustomConvert<FatcaManagerCompanyRelation | undefined> {
    serialize(relation: FatcaManagerCompanyRelation): any | undefined {
        return relation ? [String(relation)] : undefined;
    }

    deserialize(relation: any): FatcaManagerCompanyRelation | undefined {
        if (Array.isArray(relation) && relation.length > 0) {
            switch (relation[0]) {
                case '1G':
                    return FatcaManagerCompanyRelation.ENTITY_OWNERSHIP;
                case '2G':
                    return FatcaManagerCompanyRelation.ENTITY_OTHER_MEANS;
                case '3G':
                    return FatcaManagerCompanyRelation.ENTITY_HIGH_OFFICE;
                case '4G':
                    return FatcaManagerCompanyRelation.TRUSTOR_SETTLOR;
                case '5G':
                    return FatcaManagerCompanyRelation.TRUSTOR_FIDUCIARY;
                case '6G':
                    return FatcaManagerCompanyRelation.TRUSTOR_PROTECTOR;
                case '7G':
                    return FatcaManagerCompanyRelation.TRUSTOR_BENEFICIARY;
                case '8G':
                    return FatcaManagerCompanyRelation.TRUSTOR_OTHER;
                case '9G':
                    return FatcaManagerCompanyRelation.INSTRUMENT_SETTLOR;
                case 'AG':
                    return FatcaManagerCompanyRelation.INSTRUMENT_FIDUCIARY;
                case 'BG':
                    return FatcaManagerCompanyRelation.INSTRUMENT_PROTECTOR;
                case 'CG':
                    return FatcaManagerCompanyRelation.INSTRUMENT_BENEFICIARY;
                case 'DG':
                    return FatcaManagerCompanyRelation.INSTRUMENT_OTHER;
                default:
                    return undefined;
            }
        }

        return undefined;
    }
}
